import { Client } from "../models/Client";
import { Item } from "../models/ByClients/Item";
import { Declarant } from "../models/Declarant";

const updateDeclarants = (
  items: Declarant[],
  itemKey: unknown,
  newItem: Declarant
): Declarant[] => {
  const index = items.findIndex((item) => item.id === itemKey);

  if (index < 0) {
    return items;
  }

  items.splice(index, 1, newItem);

  return items;
};

const updateChildren = (
  items: Item[],
  itemKey: unknown,
  newItem: Declarant
): Item[] => {
  return items.map((item) => {
    if (!Array.isArray(item.children) || item.children.length === 0) {
      return item;
    }

    const index = item.children.findIndex((child) => child.id === itemKey);

    if (index < 0) {
      return item;
    }

    return {
      ...item,
      children: item.children.map((child, i) =>
        i === index ? newItem : child
      ),
    };
  });
};

export default function (
  data: Object[],
  itemKey: unknown,
  value: unknown,
  newItem: Declarant
): Client[] {
  return (data as Client[]).map((client) => {
    if (Array.isArray(client.children) && client.children.length > 0) {
      if (client.children.some((item) => item.id === itemKey)) {
        return {
          ...client,
          children: updateDeclarants(
            client.children as Declarant[],
            itemKey,
            newItem
          ),
        };
      }

      return {
        ...client,
        children: updateChildren(
          // @ts-ignore
          client.children,
          itemKey,
          newItem
        ) as Declarant[],
      };
    }

    return client;
  });
}
